/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/no-unescaped-entities */
/*eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps*/
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */

import React, { useState, useEffect, useRef } from "react";
import {
  FormControl,
  Button,
  AlertBanner,
  PageLoader,
} from "glic-ui-components";
import { Datepicker } from "glic-ui-components";
import { Errors } from "../../../utils/Constants/Errors";
import { Icon } from "glic-ui-components";
import { faExclamationCircle } from "glic-ui-components/dist/icons";
import { Text } from "glic-ui-components";
import { getApiData, date, codeSnippetFunc } from "../../../utils/commonFunctions";
// eslint-disable-next-line
import ReCAPTCHA from "react-google-recaptcha";
import "./index.scss";
import { get } from "lodash";
import axios from "axios";
// eslint-disable-next-line
import { GLIC_API_DOB } from "../../../utils/API/glicAPI";
import "glic-design-foundations/dist/fonts.min.css";
import { v4 as uuidv4 } from "uuid";
import { decrypt } from "../../../utils/commonFunctions";
import { MESSAGES } from "../../../utils/Constants/Messages";
import { GA_REQUEST_ID_HEADER } from "../../../utils/Constants/CommonConstants";


const DOBScreen = (props) => {
  const {
    identityToken = "",
    setNextStep,
    updateDobData,
    setUserStatus,
  } = props;

  const [dob, setDob] = useState(false);
  // eslint-disable-next-line
  const [dateError, setDateError] = useState("");
  const [correctDate, setCorrectDate] = useState("");
  // eslint-disable-next-line
  const [resData, setResData] = useState("");
  // eslint-disable-next-line
  const [errorScreeen, setErrorScreen] = useState(false);
  // eslint-disable-next-line
  const [dobApiData, setDobApiData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [recapthaScriptLoadObj, setRecapthaScriptLoadObj] = useState({});
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [recapcthaSiteKey, setRecapcthaSiteKey] = useState(null);
  const recaptchaRef = useRef(null);


  useEffect(() => {
    axios({ url: "/welcomeapi/recaptcha-key" }).then((res) => {
      const key = get(res, "data.recaptchaKey");
      setRecapcthaSiteKey(key);
    });
    wrapperApi();
  }, []);

  useEffect(() => {
    codeSnippetFunc('Page Viewed', 'Date of Birth screen');
  }, []);

  const wrapperApi = async () => {
    try {
      const body = {
        token: identityToken ?? "",
        requestType: "D",
      };
      // setIsLoading(true);
      const response = await getApiData("/wrapperproxy/", body);
      const data = await response.json();
      setIsLoading(false);
      setResData(data);
      updateDobData(data);
      if (
        data.isTokenActive === false ||
        (response.status === 404 && data.message === "ATA002")
      ) {
        setNextStep(-1);
      } else if (response.status === 404 && data.message === "ATA001") {
        setNextStep(4);
      } else if (response.status !== 200) {
        setErrorScreen(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const setError = (error, type) => {
    setDateError(error);
  };

  const cardType = () => {
    if (resData.dentalCoverage === "Y" && resData.visionCoverage === "N") {
      return "Get your Dental ID card";
    } else if (
      resData.dentalCoverage === "N" &&
      resData.visionCoverage === "Y"
    ) {
      return "Get your Vision ID card";
    } else {
      return "Get your Dental and Vision ID card";
    }
  };

  const onChangeRecaptcha = (value) => {
    setRecaptchaToken(value);
  };

  const handleBtnClick = () => {
    codeSnippetFunc('Form Step Completed', 'Get Security Code Button', 'track');
    setErrorScreen(false);
    setIsLoading(true);
    const body = {
      dob: `${correctDate}`,
      identityToken,
    };

    const response = GLIC_API_DOB.post("/dobproxy/", body, true, {
      "Content-Type": "text/plain",
     [GA_REQUEST_ID_HEADER]: uuidv4(),
      target: "checkdob",
      recaptcha_response: recaptchaToken,
    });

    response
      .then((res) => {
        recaptchaRef.current?.reset();
        setRecaptchaToken(null);
        setIsLoading(false);
        // check if identity token not found in db and redirect to Token error screen
        if (res && res?.status === 404 && res?.error_code === "ATA001") {
          setNextStep(4);
        }
        // check if token has expired and redirect to Link expired screen
        else if (
          res &&
          res?.status === 404 &&
          res?.error_code === "ATA002"
        ) {
          setNextStep(-1);
        }
        // check if entered DOB is valid or not
        else if (
          res &&
          res?.status === 404 &&
          res?.error_code === "ZVA001"
        ) {
          setError(Errors.FORMAT_ERROR_DATE);
        }
        // redirect user to otp screen
        else if (
          res &&
          res?.isTokenActive === true &&
          res?.validUser === "Y" &&
          res?.emailSent === "Y" &&
          (res?.hasDental === "Y" || res?.hasVision === "Y")
        ) {
          const plainEmailId = decrypt(res?.email).toLowerCase();
          const plainPhoneNumber = decrypt(get(res, "phoneNumber", ""));
          updateDobData(
            { ...resData, plainEmailId, plainPhoneNumber },
            correctDate
          );
          setNextStep(2);
        } else {
          setErrorScreen(true);
        }
        setDobApiData(res);
        setUserStatus(get(res, "userStatus", ""));
      })
      .catch((err) => {
        recaptchaRef.current?.reset();
        setRecaptchaToken(null);
        setIsLoading(false);
        setErrorScreen(true);
      });
  };
  const onScriptLoad = (value) => {
    setRecapthaScriptLoadObj(value);
  };

  const isDisableSecurityCodeButton =
    !dob || (!recaptchaToken && get(recapthaScriptLoadObj, "loaded"));

  const firstName =
    resData?.firstName?.charAt(0).toUpperCase() +
    resData?.firstName?.slice(1).toLowerCase();

  const planHolderName =
    resData?.planHolderName?.charAt(0).toUpperCase() +
    resData?.planHolderName?.slice(1).toLowerCase();

  const currYear = new Date().getFullYear();
  return (
    <>
      <PageLoader
        show={isLoading}
        pageLoaderText={MESSAGES.PAGE_LOADER_MESSAGE}
      />
      <div className="alert_banner_container">
        {errorScreeen && (
          <AlertBanner type="error" className="alert_banner">
            We ran into some trouble getting your ID card. Refresh the page or
            try again later. (
            {dobApiData?.system_error_code ?? dobApiData?.error_code ?? resData?.status ?? ""})({date})
          </AlertBanner>
        )}
      </div>
      {resData?.isTokenActive === true && (
        <>
          <div className="welcomeExperience__dob">
            <h1 className="welcomeExperience__bodyHeading heading">
              {resData ? cardType() : ""}
            </h1>

            <div className="welcomeExperience__topContent">
              Hi {firstName}. We’ve found your plan. Help us verify who you are
              so we can show you your card.
            </div>
            <div className="welcomeExperience__middleContent">
              <div className="middleContent__groupName heading">
                {planHolderName}
              </div>
              <div className="middleContent__groupId">
                Group ID #{resData.planNumber}
              </div>
            </div>

            <div>
              <FormControl
                className="welcomeExperience__dobInput"
                validations={{
                  required: { message: "Date Of Birth is required" },

                  date: {
                    message: "Enter a date in MM/DD/YYYY format.",
                    //eslint-disable-next-line
                    regex:
                      /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/([0-9]{4})$/,
                    //eslint-disable-line
                  },
                }}
                validateOnBlur
              >
                <FormControl.Label id="datepicker1-label" className="heading">
                  Date of Birth
                </FormControl.Label>
                <Datepicker
                  id="datepicker1"
                  name="datepicker1"
                  placeholder="MM/DD/YYYY"
                  onValueChange={(e) => {
                    setError("");
                    if (e.formatedDay !== "Invalid date") {
                      setCorrectDate(e.formatedDay);
                    }
                  }}
                  width="80%"
                  onBlur={(ref, e) => {
                    setError("");
                    if (e.formatedDay === "Invalid date") {
                      setDob(false);
                    } else {
                      setDob(true);
                      setCorrectDate(e.formatedDay);
                    }
                  }}
                  disableAutoCorrect={true}
                  yearRange={{ startYear: 1900, endYear: currYear + 3 }}
                />
              </FormControl>
              {dateError && (
                <span className="error_container">
                  <Icon
                    icon={faExclamationCircle}
                    className="exclamation_icon"
                  />
                  <Text className="error_text" role="alert">
                    {dateError}
                  </Text>
                </span>
              )}
             <div style={{ marginTop: 30 }}>
                <ReCAPTCHA
                  ref={recaptchaRef}
                  sitekey={recapcthaSiteKey}
                  onChange={onChangeRecaptcha}
                  asyncScriptOnLoad={onScriptLoad}
                />
              </div> 
            </div>
            <Button
              className={`${
                isDisableSecurityCodeButton
                  ? "welcomeExperience__grayButton"
                  : "welcomeExperience__nextButton"
              }`}
              size="small"
              onClick={handleBtnClick}
              isDisabled={isDisableSecurityCodeButton}
            >
              Get security code
            </Button>
          </div>
        </>
      )}
    </>
  );
};

export default DOBScreen;
